export const ITI_TRADES = [
  "Electrician",
  "Fitter",
  "Welder",
  "Turner",
  "Machinist",
  "CNC Programmer cum Operator",
  "Mechanic Motor Vehicle (MMV)",
  "Diesel Mechanic",
  "Electronics Mechanic",
  "Instrument Mechanic",
  "Refrigeration & Air Conditioning (RAC)",
  "Wireman",
  "Computer Operator & Programming Assistant (COPA)",
  "Information & Communication Technology System Maintenance (ICTSM)",
  "Draughtsman (Mechanical / Civil)",
  "Other",
];